import { post, downloadFile } from './request'

export const getProjectAwardBatchList = (params) => {
  return post('/service/i/manager/project/award/batchPage', params)
}

// 登录校验
export const getLoginStatus = (params) => {
  return post('/service/web/user/info/getLogin', params, { domainName: 'api' })
}

// 修改密码时间重置

export const projectUpPsd = (params) => {
  return post('/service/i/web/user/upPsd', params)
}

// 通过形审
export const projectMaterialReportXS = (params) => {
  return post('/service/i/web/project/final/xs/materialReport', params)
}
// 进入终审
export const projectMaterialReportZS = (params) => {
  return post('/service/i/web/project/final/zs/materialReport', params)
}

// 确认领奖提交
export const awardconfirm = (params) => {
  return post('/service/i/web/project/award/confirm', params)
}
export const getAwardconfirm = (params) => {
  return post('/service/i/web/project/award/get', params)
}

// 系统状态
export const getMangerStatus = (params) => {
  return post('/service/web/system/layout/get', params)
}

export const getUserInfo = (params) => {
  return post('/service/i/web/user/info', params)
}

// 导出pdf
export const exportPdf = (params) => {
  return downloadFile('/declare/i/xjwlsbMain/exportPdf', params)
}

// 项目奖下载二维码
export const getQrcodeCheckProject = (params) => {
  return post('/service/i/web/stProjectAward/declare/qrcode/check', params)
}

// 用户端-申报奖项列表接口
export const getCategoryTypeList = (params) => {
  return post('/service/i/web/award/category/project/list', params)
}
// 用户端-奖项类别相关接口
export const getCategoryList = (params) => {
  return post('/service/i/web/award/category/list', params)
}
// 用户端-项目奖申报
export const getStProjectAwardList = (params) => {
  // return post('/service/i/web/stProjectAward/page', params)
  return post('/service/i/web/stProjectAward/declare/page', params)
}
export const getStProjectAwards = (params) => {
  return post('/service/i/web/stProjectAward/declare/get', params)
  // return post('/service/i/web/stProjectAward/getAllDetail', params)
}
export const getStProjectAward = (params) => {
  // return post('/service/i/web/stProjectAward/declare/get', params)
  return post('/service/i/web/stProjectAward/getAllDetail', params)
}
export const addStProjectAward = (params) => {
  return post('/service/i/web/stProjectAward/declare/save', params)
}
// 项目奖 进入初审提示
export const getStProjectAwardCount = (params) => {
  return post('/service/i/web/stProjectAward/check/pass', params)
}
// 关闭提示
export const getStProjectAwardClear = (params) => {
  return post('/service/i/web/stProjectAward/clear/pass', params)
}
// 生成二维码  项目奖
export const getStProjectEwm = (params) => {
  return downloadFile('/service/i/web/stProjectAward/declare/generate/qrcode', params)
}
// 个人奖
export const getStPersonalEwm = (params) => {
  return downloadFile('/service/i/web/personal/declare/generate/qrcode', params)
}
// 二部分
export const addStProjectAwardTwo = (params) => {
  return post('/service/i/web/stProjectAward/examineAddOrUp', params)
}
export const getStProjectAwardTwo = (params) => {
  return post('/service/i/web/stProjectAward/examineDetails', params)
}
// 三部分
export const addStProjectAwardThree = (params) => {
  return post('/service/i/web/stProjectAward/materialReport', params)
}

// 用户端-个人奖申报相关接口
// 项目奖下载二维码
export const getQrcodeCheckPersonal = (params) => {
  return post('/service/i/web/personal/declare/qrcode/check', params)
}
export const getAwardPersonalList = (params) => {
  return post('/service/i/web/personal/page', params)
}
export const getAwardPersonals = (params) => {
  return post('/service/i/web/personal/get', params)
  // return post('/service/i/web/personal/getAllDetail', params)
}
export const getAwardPersonal = (params) => {
  // return post('/service/i/web/personal/get', params)
  return post('/service/i/web/personal/getAllDetail', params)
}
export const addAwardPersonal = (params) => {
  return post('/service/i/web/personal/award', params)
}
export const addAwardPersonalTwo = (params) => {
  return post('/service/i/web/personal/upload/review/pdf', params)
}
// 个人奖 进入初审提醒
export const getAwardPersonalNumber = (params) => {
  return post('/service/i/web/personal/check/pass', params)
}

export const getAwardPersonalClear = (params) => {
  return post('/service/i/web/personal/clear/pass', params)
}

export const addPersonalAwardThree = (params) => {
  return post('/service/i/web/personal/materialReport', params)
}

// 个人奖确认领奖
export const personalAwardconfirm = (params) => {
  return post('/service/i/web/stPersonalAwardConfirm/confirm', params)
}

export const getPersonalAwardconfirm = (params) => {
  return post('/service/i/web/stPersonalAwardConfirm/get', params)
}

// 表单部分
// 上传图片
// export const Uploadimg = (params, paramsA) => {
//   return post('/system/w/uploadFile', params, paramsA)
// }
// export const AdminDownLoadFile = (params) => {
//   return downloadFile('/system/w/downloadByPath', params)
// }
// /i/web/personal/declare/generate/qrcode
